import * as React from 'react';
import {IStateProps} from './model';

export default ({code, size}: IStateProps) => {
  if (!code) {
    return null;
  }

  return <div dangerouslySetInnerHTML={{__html: code}} style={{width: size, height: size}} />;
};
